import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public dialog: MatDialog,
      public dialogRef: MatDialogRef<ConfirmationModalComponent>) { }

  ngOnInit(): void {
    console.log("data", this.data);
    
  }

  closeAll(){
    this.dialogRef.close(false)
  }

  onSubmit(){
    this.dialogRef.close(true)
  }

}
